import React from 'react';
import { useLocation } from 'react-router-dom';

const Title = (props) => {

  let location = useLocation();

  let centeredTitles = [
    "/",
    "/forgot-password",
    "/reset-password"
  ]

  return (
    <div className="view--title">
      {props.step !== undefined ?
        <h2 className="title--container step--title">
          <span className="step--word">STEP</span>
          <span className="step--number">{props.step}</span>
          <span className="step--title">{props.title}</span>
        </h2> :
        <div className="title--container">
          <h2 className={centeredTitles.includes(location.pathname) ? "step--title centered" : "step--title"}>{props.title}</h2>
        </div>
      }
    </div>
  )
}
export default Title;